<template>
  <div class="customer-task-dropdown-component">
    <a-tooltip placement="top">
      <template slot="title">
        <span>Taken</span>
      </template>
      <a-badge :count="totalTaskCount">
        <a-button class="xl-button" shape="circle" size="large" @click="showDrawer">
          <check-icon style="margin-top: .5rem;"></check-icon>
        </a-button>
      </a-badge>
    </a-tooltip>

    <a-drawer
        placement="right"
        :visible="visible"
        @close="onClose"
        :body-style="{
          'padding': 0,
        }"
        width="60%"
    >

      <h3 style="padding: 1.5rem 0.5rem; margin-bottom: 20px">
        <a-badge :count="totalTaskCount">
          <a-button class="xl-button" shape="circle" size="large">
            <check-icon style="margin-top: .5rem;"></check-icon>
          </a-button>
        </a-badge>
        Taken
      </h3>

      <div v-if="loading" style="text-align: center; padding: 2rem;">
        Laden ...
      </div>
      <template v-if="hasTasks">
        <table class="table">
          <thead>
            <tr v-on:click.stop>
              <th colspan="1"></th>
              <th>Labels</th>
              <th>Gekoppeld aan</th>
              <th>Klant</th>
              <th>Datum</th>
              <th class="compact">Gemaakt door</th>
              <th v-if="!displayActiveTasks" class="compact">Afgerond door</th>
              <th v-if="!displayActiveTasks" class="compact">Afgerond op</th>
              <th v-if="displayActiveTasks" class="compact">Toegewezen aan</th>
              <th class="compact">Publiek</th>
              <th class="compact" colspan="4"></th>
            </tr>
          </thead>
          <tbody v-bind:class="{ loading: loading }">
          <tr v-if="!initialized">
            <td :colspan="displayActiveTasks ? 8 : 9">Laden ...</td>
          </tr>
          <TaskRowComponent
              v-for="task in tasks"
              :key="task.id"
              :displayCustomer="true"
              :displayProductLabels="true"
              :instance="instance"
              :interval="interval"
              :is-selectable="false"
              :task="task"
              :user-id="userId"
              @onCompleted="onCompleted"
              @onSelectionChanged="onSelectionChanged"
              @onUnmatched="onUnmatched"
              @onDateChanged="onDateChanged"
              @onDeleted="onDeleted"
          >
          </TaskRowComponent>
          </tbody>
        </table>
      </template>
      <div v-if="!hasTasks && !loading" style="text-align: center;" v-on:click.stop>
        <div class="no-items">
          Geen {{ displayActiveTasks ? 'openstaande' : 'afgeronde' }} taken
        </div>
      </div>
      <div style="text-align: center; padding-top: 1rem;" v-on:click.stop>
        <a-button :loading="loadingOther" v-on:click.stop="handleSwitchTaskTypeClick">
          {{ displayActiveTasks ? 'Afgeronde' : 'Openstaande' }} taken laden
        </a-button>
      </div>

    </a-drawer>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import taskApi from '~/api/task';
import store from '../../../store';
import taskModule from '../store'
import TaskRowComponent from './TaskRowComponent'

export default {
  name: "CustomersTaskDrawerComponent",
  props: {
    customerIds: {
      type: Array,
      default: null
    },
    instance: {
      type: Object,
      default: null
    },
    category: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    },
  },
  components: {
    TaskRowComponent,
  },
  data() {
    return {
      currentPage: null,
      tasks: [],
      currentRequestData: {},
      allSelected: false,
      interval: 365,
      loading: true,
      visible: false,
      loadingOther: false,
      initialized: false,
      totalTaskCount: 0,
      dropdownComponentKey: 0,
    }
  },
  created() {
    if (!store.hasModule('task')) {
      store.registerModule('task', taskModule)
    }
  },
  computed: {
    ...mapGetters('task', [
      'perPage',
      'selectedTasks'
    ]),
    indeterminate() {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.tasks.length
          && this.currentSelectionDiff > 0;
    },
    currentSelectionDiff() {
      return this.tasks.filter(i => this.selectedTasks.findIndex(x => x.id === i.id) < 0).length;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    hasSelection() {
      return this.selectedTasks.length > 0;
    },
    selectedUnlinkableTasks() {
      return this.selectedTasks.filter(task => typeof task.customer !== "undefined" && task.customer !== null)
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableTasks.length > 0;
    },
    displayActiveTasks() {
      return this.interval >= 0;
    },
    hasTasks() {
      return ((this.initialized && this.tasks.length > 0) || !this.initialized) && !this.loading;
    }
  },
  methods: {
    ...mapActions('task', [
      'setPerPage',
    ]),
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onSelectionChanged(task, selected, shiftKey) {
      if (selected === true) {
        this.selectTask(task);
      } else {
        this.deselectTask(task);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.tasks) {
        let task = this.tasks[i];

        if (this.allSelected === true && this.selectedTasks.findIndex(x => x.id === task.id) < 0) {
          this.selectTask(task);
        } else if (this.allSelected === false) {
          this.deselectTask(task);
        }
      }
    },
    selectTask(task) {
      store.dispatch('task/selectTask', task)
      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    deselectTask(task) {
      this.allSelected = false;
      store.dispatch('task/deselectTask', task)
    },
    deselectAllTasks() {
      this.allSelected = false;
      store.dispatch('task/deselectAllTasks')
    },
    forceDropdownRerender() {
      this.dropdownComponentKey += 1
    },
    loadTasksPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return;
      }
      this.currentPage = page;
      this.loading = true;

      if (this.instance === null) {
        if (this.displayActiveTasks) {
          taskApi.getActiveByCustomerIdsAndCategory(this.customerIds, this.category, this.interval, page, this.perPage)
              .then(this.handleLoadTasksSuccess)
              .catch(this.handleLoadTasksError);
        } else {
          taskApi.getCompletedByCustomerIdsAndCategory(this.customerIds, this.category, this.interval, page, this.perPage)
              .then(this.handleLoadTasksSuccess)
              .catch(this.handleLoadTasksError);
        }
      } else {
        if (this.displayActiveTasks) {
          taskApi.getActiveByInstance(this.instance, this.interval, page, this.perPage)
              .then(this.handleLoadTasksSuccess)
              .catch(this.handleLoadTasksError);
        } else {
          taskApi.getCompletedByInstance(this.instance, this.interval, page, this.perPage)
              .then(this.handleLoadTasksSuccess)
              .catch(this.handleLoadTasksError);
        }
      }
    },
    handleLoadTasksSuccess(response) {
      this.allSelected = false;
      this.tasks = response.data;
      this.currentRequestData = response;
      this.loading = false;
      this.loadingOther = false;
      this.initialized = true;
      this.totalTaskCount = response.meta.pagination.total;
      this.forceDropdownRerender();
    },
    handleLoadTasksError(exception) {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om taken te laden',
      });
    },
    onUnmatchAllClick() {
      this.loading = true;

      taskApi.unmatchTasks(this._.map(this.selectedTasks, 'id')).then(() => {
        this.loading = false;
        // trigger reload
        for (let i in this.selectedTasks) {
          this.selectedTasks[i].customer = null;
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet ontkoppelen',
        });
      });
    },
    onCompleteAllClick() {
      this.loading = true;
      taskApi.completeTasks(this._.map(this.selectedTasks, 'id'), this.userId, this.interval).then(response => {
        // trigger reload
        this.loadTasksPage(this.page, true);
        this.deselectAllTasks();
      }).catch(error => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet verwerken',
        });
      });
    },
    processBadges(badge, count) {
      let $badge = $(badge);
      if (count === 0) {
        $badge.addClass('hidden');
      } else {
        $badge.removeClass('hidden').text(count);
      }
    },
    onCompleted() {
      this.loadTasksPage(this.currentPage, true);
    },
    onUnmatched() {
      // this.loadTasksPage(this.page);
    },
    onDateChanged () {
      this.loadTasksPage(this.currentPage, true)
    },
    onDeleted () {
      this.loadTasksPage(this.currentPage, true)
    },
    handlePerPageChange(perPage) {
      this.setPerPage(perPage);
      this.loadTasksPage(this.page, true);
    },
    handleSwitchTaskTypeClick() {
      if (this.displayActiveTasks) {
        this.interval = -365;
      } else {
        this.interval = 365;
      }
      this.loadingOther = true;
      this.loadTasksPage(1, true);
    }
  },
  mounted() {
    this.loadTasksPage(this.page);
  }
}
</script>

<style scoped>
.overlay {
  background-color: white;
  min-width: 800px;
  max-height: 800px;
  padding: 1rem;
  border-radius: 0.4rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.overlay .table {
  margin: 0;
}

.no-items {
  text-align: center;
  padding: 2rem;
}

.xl-button {
  width: 45px;
  height: 45px;
}
</style>
